import React from 'react';

import { Box } from '@components/Restyle';
import { Skeleton } from '@components/shared/Skeleton';
import theme from '@themes/theme';

/**
 * Assignee row placeholder: avatar + name line. Used in the task detail
 * panel's Assignee section and the invite/add-assignee modal's member list.
 */
export const AssigneeRowSkeleton: React.FC<{ testID?: string }> = ({
  testID = 'assignee-row-skeleton',
}) => {
  return (
    <Box
      testID={testID}
      flexDirection='row'
      alignItems='center'
      paddingVertical='s'>
      <Skeleton
        variant='circle'
        width={28}
        height={28}
        style={{ marginRight: theme.spacing.s }}
      />
      <Box flex={1}>
        <Skeleton variant='text' width='45%' />
      </Box>
    </Box>
  );
};
